import axios from 'axios';
import {DqResponse} from 'generated/JavaTOmodifications';

interface Args {
	dqkey: string
	params?: { [key in string]: any }
	filter?: string
	url?: string
	isAze?: boolean
}

export function fetchDqAPI({dqkey, params, filter, url = '../json/aacf', isAze}: Args) {
	return axios.request<DqResponse>({
		url,
		method: 'POST' as const,
		data: {
			id: dqkey,
			params,
			filter,
			isAze,
		},
	})
}